class Comprobante {
    constructor(idLiquidacionComprobanteTransferencia,pyid,nroFactura,nroDocumento,banco,cbu,fechaInterbanking,nroTransferencia,nroRed,monto,ctaBancaria,fechaIntegracion,bancoDebito,cbuDebito,caratulaJuicio){
      this.idLiquidacionComprobanteTransferencia=idLiquidacionComprobanteTransferencia
      this.pyid=pyid
      this.nroFactura=nroFactura
      this.nroDocumento=nroDocumento
      this.banco=banco
      this.cbu=cbu
      this.fechaInterbanking=fechaInterbanking
      this.nroTransferencia=nroTransferencia
      this.nroRed=nroRed
      this.monto=monto
      this.ctaBancaria=ctaBancaria
      this.fechaIntegracion=fechaIntegracion
      this.bancoDebito=bancoDebito
      this.cbuDebito=cbuDebito
      this.caratulaJuicio=caratulaJuicio
    }
  }
  
  export default Comprobante
  